import { StatusCodes } from "http-status-codes";
import { Langs } from "./domain/enums/common/LangsEnum";
import { PaginationEnum } from "./domain/enums/common/PaginationEnum";

export const translations = {
    ua: {
        translation: {
            common: {
                back: "Назад",
                scrollToTop: "Повернутись вгору",
            },
            buttons: {
                viewProjects: "дивитись наші проєкти",
                learnMore: "дізнатись більше",
                moreEvents: "більше подій",
                moreMaterials: "більше навчальних матеріалів",
                moreNews: "більше новин",
                register: "Зареєстуватися",
                becomePartner: "Стати партнером",
                moreDetails: "Детальніше",
                share: "Поділитися",
                copy: "Копіювати",
            },
            languages: {
                [Langs.UA]: "Українська",
                [Langs.EN]: "Англійська",
            },
            pagination: {
                show: "Показувати",
                [PaginationEnum.SHOW_ALL]: "Всі",
                [PaginationEnum.SHOW_10]: "10",
                [PaginationEnum.SHOW_20]: "20",
                [PaginationEnum.SHOW_50]: "50",
                [PaginationEnum.SHOW_100]: "100",
            },
            errors: {
                common: "Несподівана помилка",
                validation: {
                    min: "Мінімальне значення ",
                    max: "Максимальне значення ",
                    required: "Обов'язкове поле",
                    invalidOption: "Некоректне значення",
                    invalidNumber: "Некоректне число",
                    invalidEmail: "Некоректна адреса електронної пошти",
                    requireAtLeastOne:
                        "Обов'язкова наявність хоча б одного з полів",
                    invalidPhone: "Некоректний номер телефону",
                    password: {
                        minSymbols:
                            "Мінімальна кількість спеціальних символів - 1",
                        minLowercase:
                            "Мінімальна кількість символів в нижньому регістрі - 1",
                        minUppercase:
                            "Мінімальна кількість символів в верхньому регістрі - 1",
                        minNumbers: "Мінімальна кількість чисел - 1",
                        passwordsMustMatch: "Паролі не співпадають",
                    },
                    syntaxError: "Присутнє некоректне значення",
                },
                response: {
                    [StatusCodes.UNAUTHORIZED]:
                        "Несанкціонований доступ або невірний пароль",
                    [StatusCodes.BAD_REQUEST]: "Присутнє некоректне значення",
                },
            },
            auth: {
                fields: {
                    firstName: "Ім'я",
                    lastName: "Прізвище",
                    middleName: "По-батькові",
                    email: "Електронна пошта",
                    phone: "Телефон",
                    password: "Пароль",
                    confirmPassword: "Підтвердження паролю",
                },
                actions: {
                    register: "Зареєструватися",
                    login: "Увійти",
                    logout: "Вийти",
                    changePassword: "Змінити пароль",
                },
                register: {
                    title: "Реєстрація",
                    success:
                        "Реєстрація успішна! Будь ласка, перевірте вашу електронну пошту для підтвердження.",
                },
                login: {
                    title: "Вхід",
                },
                confirmation: {
                    title: "Підтвердження реєстрації",
                    subtitle:
                        "Будь ласка, зачекайте, поки ми підтвердимо вашу реєстрацію.",
                    subtitleLink: "Перейти на головну",
                    inProcess: "Обробка...",
                    error: "Сталася помилка під час підтвердження.",
                    alreadyExist: "Цей обліковий запис вже підтверджено.",
                    expired: "Термін дії токена підтвердження закінчився.",
                    success: "Ваш обліковий запис успішно підтверджено!",
                    link: "Перейти до авторизації",
                },
            },
            messages: {
                received: "Список користувачів отримано",
                rolesReceived: "Список ролей отримано",
                productFeaturesReceived: "Список функцій продукту отримано",
                changesApplied: "Зміни були застосовані",
            },
            home: {
                directionsFeatureItems: [
                    {
                        title: "Штучний інтелект та машинне навчання",
                        description:
                            "Автоматизація процесів, предиктивна аналітика, нейромережі",
                        icon: "focus-1",
                        size: "small",
                    },
                    {
                        title: "Інтернет речей (IoT) та кіберфізичні системи",
                        description:
                            "Розумні міста, сенсорні мережі, цифрова екологія",
                        icon: "focus-2",
                        size: "small",
                    },
                    {
                        title: "Кібербезпека та захист критичної інфраструктури",
                        description: "Симуляція кібератак, розробка IDS/IPS",
                        icon: "focus-3",
                        size: "small",
                    },
                    {
                        title: "Великі дані та бізнес-аналітика",
                        description:
                            "Аналітика для урбаністики, економіки та промисловості",
                        icon: "focus-4",
                        size: "small",
                    },
                    {
                        title: "Хмарні обчислення та розподілені системи",
                        description: "Хмарні обчислення та розподілені системи",
                        icon: "focus1-1",
                        size: "large",
                    },
                    {
                        title: "Вбудовані системи та розумне ПЗ",
                        description: "Розробка для SCADA/ICS, IoT-девайсів",
                        icon: "focus1-2",
                        size: "large",
                    },
                    {
                        title: "Комп’ютерне зору та обробка сигналів",
                        description:
                            "Розпізнавання обличчя, відеоаналіз, класифікація даних",
                        icon: "focus1-3",
                        size: "large",
                    },
                ],

                nav: {
                    about: "Про нас",
                    news: "Новини та заходи",
                    projects: "Проєкти",
                    education: "Навчальні матеріали",
                    cooperation: "Співпраця",
                    forum: "Форум",
                },
                pageTitle: "Інноваційний центр розвитку інтелектуальних систем",
                subtitle:
                    "Навчально-наукового інституту комп'ютерних наук та штучного інтелекту ХНУ ім. В. Н. Каразіна",
                description:
                    "Платформа для освіти, досліджень та технологій майбутнього в серці Каразінського університету",
                headings: {
                    mission: "Наша місія — змінювати майбутнє через інтелект",
                    aboutUs: "Хто ми такі?",
                    directions: "Напрями діяльності",
                    events: "Анонси подій",
                    materials: "Навчальні матеріали",
                    news: "Останні новини",
                    contacts: "Контакти",
                    partners: "Наші партнери",
                    weProvide: "Ми надаємо:",
                },
                paragraphs: {
                    mission:
                        "Ми віримо, що освіта, наука і технології мають працювати разом. Наша мета — підготувати фахівців, здатних вирішувати складні виклики цифрового світу.",
                    events: "Слідкуйте за нашими заходами, хакатонами, курсами та відкритими зустрічами. Долучайтесь, щоб навчатися, розвиватися та бути в центрі технологічних змін.",
                    aboutUsDescription: [
                        "це сучасний міждисциплінарний майданчик, створений для досліджень, навчання та впровадження передових технологій у сфері штучного інтелекту, кібербезпеки, обробки даних та інтернету речей.",
                        {
                            before: "Ми є частиною ",
                            highlight:
                                "Навчально-наукового інституту комп’ютерних наук та штучного інтелекту ХНУ імені В. Н. Каразіна",
                            after: ", і працюємо в тісній взаємодії з науковими школами, викладачами, студентами та партнерами з галузі ІТ.",
                        },
                        "Центр об'єднує талановитих дослідників, інженерів, викладачів і студентів, які прагнуть створювати інноваційні продукти та рішення, здатні змінити світ навколо нас. Ми забезпечуємо простір, ресурси та підтримку для реалізації наукових ідей, запуску стартапів та розробки технологічних рішень на глобальному рівні.",
                    ],
                    directionsDescription: [
                        "Центр працює на стику найактуальніших галузей сучасної ІТ-індустрії",
                    ],
                    educationDescription: [
                        "У цьому розділі зібрані навчальні ресурси від викладачів та експертів Інноваційного Центру. Ви знайдете як базові курси, так і спеціалізовані матеріали для поглибленого вивчення технологій штучного інтелекту, обробки даних, кібербезпеки, IoT та інших напрямів.",
                        "Навчальні матеріали регулярно оновлюються, більшість з них доступні онлайн і безкоштовно. Частина курсів супроводжується сертифікацією.",
                    ],
                    weProvideItems: [
                        {
                            title: "Доступ до дослідницької інфраструктури",
                            icon: "laptop",
                        },
                        {
                            title: "Співпрацю з лідерами ІТ-галузі",
                            icon: "star",
                        },
                        {
                            title: "Можливості участі в проєктах і стартапах",
                            icon: "search",
                        },
                        {
                            title: "Простір для ідей, розвитку та інновацій",
                            icon: "brain",
                        },
                    ],
                },
                contacts: {
                    addressLabel: "📍 Адреса:",
                    addressText: "Площа Свободи, 6, м. Харків, 61022, Україна",
                    phoneLabel: "📞 Телефон:",
                    phoneText: "+380509646726",
                    emailLabel: "✉️ Email:",
                    emailText: "csai.innovation@karazin.ua",
                    directorLabel: "👨🏻‍💼 Директор:",
                    directorText: "Сергій Бурченко",
                    websiteLabel: "🔗 Сайт:",
                    websiteText: "csai.karazin.ua",
                },
                educationCards: [
                    // {
                    //     title: "Відеолекції",
                    //     text: "Записи з воркшопів, лекцій, гостьових подій",
                    //     icon: "video",
                    //     stats: "74 матеріали",
                    // },
                    // {
                    //     title: "Статті та методички",
                    //     text: "Авторські розробки, PDF-довідники, інструкції",
                    //     icon: "article",
                    //     stats: "1032 матеріали",
                    // },
                    // {
                    //     title: "Завантаження",
                    //     text: "Шаблони, презентації, вихідні коди, датасети",
                    //     icon: "download",
                    //     stats: "14 матеріалів",
                    // },
                    // {
                    //     title: "Інтеграція з YouTube",
                    //     text: "Плейлист Центру з відеоуроками",
                    //     icon: "integration",
                    //     stats: "8 матеріалів",
                    // },
                    {
                        title: "Курси",
                        text: "Самостійне навчання за програмами Центру",
                        icon: "course",
                        stats: "6 матеріалів",
                    },
                ],

                eventsWhenWhereTitle: "📅 Коли? Де?",
                eventsCards: [
                    {
                        title: "Хакатон",
                        subtitle:
                            "«AI для міста»: вирішуємо реальні задачі громади",
                        date: "12–13 серпня 2025",
                        location: "ОНЛАЙН",
                        image: "event-hackathon",
                        description:
                            "Дводенний хакатон, на якому учасники розроблятимуть рішення на базі штучного інтелекту для міських сервісів — екологія, транспорт, безпека. Призи, ментори, нетворкінг!",
                    },
                    {
                        title: "Воркшоп",
                        subtitle: "Розгортання IoT-систем від А до Я",
                        date: "22 липня 2025",
                        location: "Лабораторія Центру",
                        image: "event-workshop",
                        description:
                            "Практичний воркшоп з побудови повноцінної IoT-мережі: сенсори, мікроконтролери, обмін даними. Під керівництвом інженерів Центру.",
                    },
                ],
                directionsItems: [
                    {
                        title: "Штучний інтелект та машинне навчання",
                        subtitle:
                            "Автоматизація процесів, предиктивна аналітика, нейромережі",
                        icon: "focus-1",
                    },
                    {
                        title: "Інтернет речей (IoT) та кіберфізичні системи",
                        subtitle:
                            "Розумні міста, сенсорні мережі, цифрова екологія",
                        icon: "focus-2",
                    },
                    {
                        title: "Кібербезпека та захист критичної інфраструктури",
                        subtitle: "Симуляція кібератак, розробка IDS/IPS",
                        icon: "focus-3",
                    },
                    {
                        title: "Великі дані та бізнес-аналітика",
                        subtitle:
                            "Аналітика для урбаністики, економіки та промисловості",
                        icon: "focus-4",
                    },
                    {
                        title: "Хмарні обчислення та розподілені системи",
                        subtitle: "Хмарні обчислення та розподілені системи",
                        icon: "focus1-1",
                    },
                    {
                        title: "Вбудовані системи та розумне ПЗ",
                        subtitle: "Розробка для SCADA/ICS, IoT-девайсів",
                        icon: "focus1-2",
                    },
                    {
                        title: "Комп’ютерне зору та обробка сигналів",
                        subtitle:
                            "Розпізнавання обличчя, відеоаналіз, класифікація даних",
                        icon: "focus1-3",
                    },
                ],
                subheadings: {
                    aboutUs:
                        "Інноваційний центр розвитку інтелектуальних систем",
                    directions: "Ключові технологічні напрями",
                    materials:
                        "Відкритий доступ до знань — для студентів, викладачів, дослідників і всіх, хто прагне опанувати інтелектуальні технології. Теорія, практика, сертифікація.",
                    contacts: "Зв’яжіться з нами",
                },
                missionPoints: [
                    {
                        title: "Розвиток",
                        subtitle: "особистісне та професійне зростання",
                        icon: "growth",
                    },
                    {
                        title: "Співпраця",
                        subtitle: "міждисциплінарна взаємодія",
                        icon: "cooperation",
                    },
                    {
                        title: "Інновації",
                        subtitle: "постійний пошук нових рішень",
                        icon: "innovation",
                    },
                    {
                        title: "Безпека",
                        subtitle: "захист цифрового простору",
                        icon: "security",
                    },
                    {
                        title: "Відкритість",
                        subtitle: "інтеграція у світовий науковий простір",
                        icon: "openness",
                    },
                ],
                newsCards: [
                    {
                        title: "Студенти Центру здобули перемогу на всеукраїнському хакатоні",
                        text: "Команда з ННІ комп’ютерних наук розробила систему виявлення кібератак у реальному часі та здобула І місце на хакатоні «CyberHack 2025». Вітаємо переможців!",
                        image: "news-1",
                    },
                    {
                        title: "Новий курс з машинного навчання стартує у вересні",
                        text: "Центр відкриває набір на авторський курс «AI з нуля до проєкту». Програма включає реальні задачі, менторство від експертів та сертифікацію. Кількість місць обмежена.",
                        image: "news-2",
                    },
                    {
                        title: "Новий курс з машинного навчання стартує у вересні",
                        text: "Інноваційний Центр став учасником європейського проєкту з розвитку кіберфізичних систем у критичній інфраструктурі. Попереду — нові спільні дослідження та обміни.",
                        image: "news-3",
                    },
                ],
                footerLinks: {
                    column1: ["Про нас", "Новини", "Проєкти", "Анонси подій"],
                    column2: [
                        "Навчальні матеріали",
                        "Форум",
                        "Співпраця",
                        "Мій акаунт",
                    ],
                },
                newsletter: {
                    title: "Хочете бути в курсі подій? Залиште свій Email",
                    placeholder: "Email",
                    button: "Підписатись",
                },
                footer: {
                    copyrightLine1:
                        "© 2025 Інноваційний центр розвитку інтелектуальних систем",
                    copyrightLine2:
                        "Харківський національний університет імені В. Н. Каразіна. Усі права захищені.",
                },
                common: {
                    scrollToTop: "Повернутись вгору",
                },
                aboutUs: {
                    alt: "Ілюстрація до секції Про нас",
                },
            },
            events: {
                location: {
                    online: "Онлайн",
                    laboratory_center: "Лабораторія Центру",
                },
                format: {
                    online: "Онлайн",
                    offline: "Офлайн",
                    hybrid: "Гібридний",
                },
            },
            about: {
                pageTitle: "Про нас",
                subtitle:
                    "Інноваційний центр розвитку інтелектуальних систем — структурний підрозділ Навчально-наукового інституту комп'ютерних наук та штучного інтелекту, заснований 2025 року, який займається підвищенням комп'ютерної грамотності, міжнародною сертифікацією та просвітницькою діяльністю в ІТ галузі.",
                headings: {
                    leadership: "Керівництво центру",
                    developmentHistory: "історія розвитку",
                },
                paragraphs: {
                    developmentHistory: ["Кроки становлення та зростання"],
                    leadershipTitle: "Лідери, що формують розвиток",
                    leadershipText:
                        "Керівники центру визначають стратегію, координують освітні проєкти та впроваджують сучасні ІТ-рішення.",
                },
                leadership: [
                    {
                        name: "Савченко Ірина Олександрівна",
                        position: "Заступник декана з наукової роботи",
                    },
                    {
                        name: "Гриненко Наталія Іванівна",
                        position: "Заступник декана з навчальної роботи",
                    },
                    {
                        name: "Мельник Андрій Петрови",
                        position: "Голова науково-дослідної ради факультету",
                    },
                    {
                        name: "Ковальчук Олена Вікторівна",
                        position: "Координатор міжнародних програм",
                    },
                    {
                        name: "Бурченко Сергій Борисович",
                        position:
                            "Директор Інноваційного центру розвитку інтелектуальних систем",
                    },
                    {
                        name: "Шевченко Світлана Михайлівна",
                        position:
                            "Керівник навчально-методичного відділу,заступник декана з навчальної роботи",
                    },
                ],
                history: {
                    founding: "2007 — Заснування",
                    foundingDescription:
                        "Створення Інформаційного центру на базі кафедри комп’ютерних наук. Формування першої команди та запуск базових курсів з програмування й комп’ютерної грамотності.",
                    expansion: "2008–2012 — Розширення освітніх можливостей",
                    expansionDescription:
                        "Розширення спектру навчальних програм, збільшення кількості слухачів та викладачів, створення нових курсів у галузі інформаційних технологій.",
                    recognition: "2013–2018 — Міжнародне визнання",
                    recognitionDescription:
                        "Створення локальної академії Cisco, впровадження сертифікаційних курсів світового рівня, зростання кількості партнерів та слухачів.",
                    innovation: "2019 – сьогодні — Інновації та партнерство",
                    innovationDescription:
                        "Розвиток новітніх навчальних програм, посилення міжнародного співробітництва, проведення конференцій та впровадження інноваційних ІТ-рішень.",
                },
            },
            news: {
                notFound: "Новину не знайдено",
                pageTitle: "Новини",
                loadError: "Помилка завантаження новин",
                filters: {
                    sortBy: "Сортувати за:",
                    datePublication: "Дата публікації",
                    dateNew: "Новіші",
                    dateOld: "Старіші",
                    popularity: "Популярність",
                    mostPopular: "Найпопулярніші",
                    lessPopular: "Менш популярні",
                    listGroup: "Список",
                    nameAZ: "За назвою (А-Я)",
                    nameZA: "За назвою (Я-А)",
                    similarSection: {
                        title: "Схожі новини",
                    },
                    share: {
                        title: "Поділитись",
                        instagramApp:
                            "Поширення Instagram доступне лише через мобільний додаток",
                        copied: "Посилання скопійовано!",
                    },
                },
                meta: {
                    author: "Автор",
                    views: "Переглядів",
                    defaultAuthor: "Команда Інноваційного центру",
                },
            },
            courses: {
                notFound: "Курс не знайдено",
                pageTitle: "Курси",
                loadError: "Помилка завантаження курсів",
                noCourses: "Курси не знайдено",
                goToCourse: "Перейти на курс",
                author: "Автор",
                duration: "Тривалість",
                topic: "Тема",
                date: "Дата",
                program: {
                    title: "Програма курсу",
                    placeholder:
                        "Інформація про програму курсу буде доступна незабаром",
                },
                similarSection: {
                    title: "Вам також може бути цікаво",
                },
                filters: {
                    sortBy: "Сортувати за:",
                    dateNew: "Новіші",
                    dateOld: "Старіші",
                    nameAZ: "За назвою (А-Я)",
                    nameZA: "За назвою (Я-А)",
                },
            },
            educationalMaterials: {
                pageTitle: "Навчальні матеріали",
                topics: {
                    title: "Теми",
                    clearAll: "Очистити фільтри",
                    expand: "Розгорнути",
                    collapse: "Згорнути",
                    ai: "Штучний інтелект",
                    data_analysis: "Аналіз даних",
                    programming: "Програмування",
                    cybersecurity: "Кібербезпека",
                    iot: "Інтернет речей",
                    research: "Наукові дослідження",
                    startups: "Інновації та стартапи",
                    ai_ethics: "Етика AI",
                },
                filters: {
                    title: "Фільтри",
                    sortBy: "Сортувати за:",
                },
                courses: {
                    title: "Курси",
                    noCourses: "Курси не знайдено",
                    moreCourses: "Більше курсів",
                },
            },
            account: {
                pageTitle: "Мій акаунт",
                accountInformation: {
                    fullName: "ПІБ",
                    firstName: "Ім'я",
                    middleName: "По батькові",
                    lastName: "Прізвище",
                    rating: "Рейтинг",
                    accountDescription: "Опис акаунту",
                    role: "Роль",
                    telephone: "Телефон",
                    email: "Електронна пошта",
                    receiveNewsEmail: "Отримувати новини на email",
                    descriptionMissing: "Опис відсутній...",
                    position: "Посада",
                },
                buttonText: {
                    edit: "Редагувати",
                    share: "Поділитися",
                    exiteAccount: "Вийти з укаунту",
                    downloadData: "Додати файли",
                    deleteAccount: "Видалити акаунт?",
                    saveChanges: "Зберегти",
                    cancelSaving: "Скасувати",
                    editePhoto: "Змінити фото",
                    uploadPhoto: "Завантажити фото",
                    deletePhoto: "Видалити фото"
                },
                userData: {
                    dataStorage: "Мої збережені дані",
                    events: "Мої події",
                    attachedFiles: "Мої додані файли",
                    deleted: "Видалений",
                },
                loadError: "Помилка при збереженні даних",
            },
        },
    },

    en: {
        translation: {
            common: {
                back: "Back",
                scrollToTop: "Scroll to top",
            },
            buttons: {
                viewProjects: "view our projects",
                learnMore: "learn more",
                moreEvents: "more events",
                moreMaterials: "more educational materials",
                moreNews: "more news",
                register: "Register",
                becomePartner: "Become a partner",
                moreDetails: "More details",
                share: "Share",
                copy: "Copy",
            },

            languages: {
                [Langs.UA]: "Ukrainian",
                [Langs.EN]: "English",
            },
            pagination: {
                show: "Show",
                [PaginationEnum.SHOW_ALL]: "All",
                [PaginationEnum.SHOW_10]: "10",
                [PaginationEnum.SHOW_20]: "20",
                [PaginationEnum.SHOW_50]: "50",
                [PaginationEnum.SHOW_100]: "100",
            },
            errors: {
                common: "Unexpected error",
                validation: {
                    min: "Minimal value ",
                    max: "Maximum value ",
                    required: "Required field",
                    invalidOption: "Invalid option",
                    invalidNumber: "Invalid number",
                    invalidEmail: "Invalid email address",
                    requireAtLeastOne: "Require at least one of fields",
                    invalidPhone: "Invalid phone number",
                    password: {
                        minSymbols: "Minimum number of special characters - 1",
                        minLowercase: "Minimum lowercase character - 1",
                        minUppercase: "Minimum uppercase character - 1",
                        minNumbers: "Minimum number of numbers - 1",
                        passwordsMustMatch: "Passwords do not match",
                    },
                    syntaxError: "Invalid value is present",
                },
                response: {
                    [StatusCodes.UNAUTHORIZED]:
                        "Unauthorized access or incorrect password",
                    [StatusCodes.BAD_REQUEST]: "Invalid value is present",
                },
            },
            auth: {
                fields: {
                    firstName: "First Name",
                    lastName: "Last Name",
                    middleName: "Middle Name",
                    email: "Email",
                    phone: "Phone",
                    password: "Password",
                    confirmPassword: "Confirm Password",
                },
                actions: {
                    register: "Register",
                    login: "Login",
                    logout: "Logout",
                    changePassword: "Change Password",
                },
                register: {
                    title: "Register",
                    success:
                        "Registration successful! Please check your email for confirmation.",
                },
                login: {
                    title: "Login",
                },
                confirmation: {
                    title: "Registration Confirmation",
                    subtitle: "Please wait while we confirm your registration.",
                    subtitleLink: "Go to Home",
                    inProcess: "Processing...",
                    error: "An error occurred during confirmation.",
                    alreadyExist: "This account has already been confirmed.",
                    expired: "The confirmation token has expired.",
                    success: "Your account has been successfully confirmed!",
                    link: "Go to Login",
                },
            },
            messages: {
                received: "Users received",
                rolesReceived: "Roles received",
                productFeaturesReceived: "Product features received",
                changesApplied: "Changes has been applied",
            },
            home: {
                directionsFeatureItems: [
                    {
                        title: "Artificial Intelligence and Machine Learning",
                        description:
                            "Process automation, predictive analytics, neural networks",
                        icon: "focus-1",
                        size: "small",
                    },
                    {
                        title: "Internet of Things (IoT) and Cyber-Physical Systems",
                        description:
                            "Smart cities, sensor networks, digital ecology",
                        icon: "focus-2",
                        size: "small",
                    },
                    {
                        title: "Cybersecurity and Critical Infrastructure Protection",
                        description:
                            "Cyberattack simulation, IDS/IPS development",
                        icon: "focus-3",
                        size: "small",
                    },
                    {
                        title: "Big Data and Business Analytics",
                        description:
                            "Analytics for urbanism, economics, and industry",
                        icon: "focus-4",
                        size: "small",
                    },
                    {
                        title: "Cloud Computing and Distributed Systems",
                        description: "Cloud computing and distributed systems",
                        icon: "focus1-1",
                        size: "large",
                    },
                    {
                        title: "Embedded Systems and Intelligent Software",
                        description: "Development for SCADA/ICS, IoT devices",
                        icon: "focus1-2",
                        size: "large",
                    },
                    {
                        title: "Computer Vision and Signal Processing",
                        description:
                            "Face recognition, video analysis, data classification",
                        icon: "focus1-3",
                        size: "large",
                    },
                ],
                nav: {
                    about: "About us",
                    news: "News and events",
                    projects: "Projects",
                    education: "Educational materials",
                    cooperation: "Cooperation",
                    forum: "Forum",
                },
                pageTitle:
                    "Innovation Center for Intelligent Systems Development",
                subtitle:
                    "Educational and Research Institute of Computer Science and Artificial Intelligence at V. N. Karazin Kharkiv National University",
                description:
                    "A platform for education, research, and future technologies at the heart of Karazin University",
                headings: {
                    mission:
                        "Our mission — to change the future through intelligence",
                    aboutUs: "Who are we?",
                    directions: "Areas of activity",
                    events: "Event announcements",
                    materials: "Educational materials",
                    news: "Latest news",
                    contacts: "Contacts",
                    partners: "Our partners",
                    weProvide: "We provide:",
                },
                paragraphs: {
                    mission:
                        "We believe education, science, and technology must work together. Our goal is to prepare specialists capable of solving complex challenges of the digital world.",
                    events: "Follow our events, hackathons, courses, and open meetings. Join us to learn, grow, and be at the center of technological change.",
                    aboutUsDescription: [
                        "is a modern interdisciplinary platform created for research, education, and implementation of advanced technologies in artificial intelligence, cybersecurity, data processing, and the Internet of Things.",
                        {
                            before: "We are part of the ",
                            highlight:
                                "Educational and Research Institute of Computer Science and Artificial Intelligence at V. N. Karazin Kharkiv National University",
                            after: ", and work closely with scientific schools, faculty, students, and IT industry partners.",
                        },
                        "The center unites talented researchers, engineers, teachers, and students who strive to create innovative products and solutions that can change the world around us. We provide space, resources, and support for implementing scientific ideas, launching startups, and developing technological solutions on a global scale.",
                    ],
                    directionsDescription: [
                        "The center operates at the intersection of the most relevant fields of the modern IT industry",
                    ],
                    educationDescription: [
                        "This section gathers educational resources from the Center's instructors and experts. You will find both basic courses and specialized materials for in-depth study of AI technologies, data processing, cybersecurity, IoT, and other directions.",
                        "Educational materials are regularly updated, most are available online and free of charge. Some courses come with certification.",
                    ],
                    weProvideItems: [
                        {
                            title: "Access to research infrastructure",
                            icon: "laptop",
                        },
                        {
                            title: "Collaboration with IT industry leaders",
                            icon: "star",
                        },
                        {
                            title: "Opportunities to participate in projects and startups",
                            icon: "search",
                        },
                        {
                            title: "Space for ideas, development, and innovation",
                            icon: "brain",
                        },
                    ],
                },
                contacts: {
                    addressLabel: "📍 Address:",
                    addressText: "Svobody Square, 6, Kharkiv, 61022, Ukraine",
                    phoneLabel: "📞 Phone:",
                    phoneText: "+380509646726",
                    emailLabel: "✉️ Email:",
                    emailText: "csai.innovation@karazin.ua",
                    directorLabel: "👨🏻‍💼 Director:",
                    directorText: "Serhii Burchenko",
                    websiteLabel: "🔗 Website:",
                    websiteText: "csai.karazin.ua",
                },
                educationCards: [
                    // {
                    //     title: "Video lectures",
                    //     text: "Recordings of workshops, lectures, guest events",
                    //     icon: "video",
                    //     stats: "74 materials",
                    // },
                    // {
                    //     title: "Articles and manuals",
                    //     text: "Author's developments, PDF guides, instructions",
                    //     icon: "article",
                    //     stats: "1032 materials",
                    // },
                    // {
                    //     title: "Downloads",
                    //     text: "Templates, presentations, source codes, datasets",
                    //     icon: "download",
                    //     stats: "14 materials",
                    // },
                    // {
                    //     title: "YouTube integration",
                    //     text: "Center's playlist with video lessons",
                    //     icon: "integration",
                    //     stats: "8 materials",
                    // },
                    {
                        title: "Courses",
                        text: "Self-study according to the Center's programs",
                        icon: "course",
                        stats: "6 materials",
                    },
                ],
                account: {
                    pageTitle: "My Account",
                    accountInformation: {
                        fullName: "Full Name",
                        lastName: "Last Name",
                        firstName: "First Name",
                        middleName: "Middle Name",
                        rating: "Rating",
                        accountDescription: "Account Description",
                        role: "Role",
                        telephone: "Phone",
                        email: "Email",
                        receiveNewsEmail: "Receive news by email",
                        descriptionMissing: "Description is missing...",
                        position: "Position",
                    },
                    buttonText: {
                        edit: "Edit",
                        share: "Share",
                        exiteAccount: "Exit Account",
                        downloadData: "Add Files",
                        deleteAccount: "Delete Account?",
                        saveChanges: "Save",
                        cancelSaving: "Cancel",
                        editePhoto: "Edit Photo",
                        uploadPhoto: "Upload Photo",
                        deletePhoto: "Delete Photo"
                    },
                    userData: {
                        dataStorage: "My Saved Data",
                        events: "My Events",
                        attachedFiles: "My Attached Files",
                        deleted: "Deleted",
                    },
                    loadError: "Error saving data",
                },
                eventsWhenWhereTitle: "📅 When? Where?",
                eventsCards: [
                    {
                        title: "Hackathon",
                        subtitle:
                            "“AI for the city”: solving real community problems",
                        date: "August 12–13, 2025",
                        location: "ONLINE",
                        image: "event-hackathon",
                        description:
                            "A two-day hackathon where participants will develop AI-based solutions for urban services — ecology, transport, safety. Prizes, mentors, networking!",
                    },
                    {
                        title: "Workshop",
                        subtitle: "Deploying IoT systems from A to Z",
                        date: "July 22, 2025",
                        location: "Center Laboratory",
                        image: "event-workshop",
                        description:
                            "A practical workshop on building a full IoT network: sensors, microcontrollers, data exchange. Led by the Center’s engineers.",
                    },
                ],
                directionsItems: [
                    {
                        title: "Artificial intelligence and machine learning",
                        subtitle:
                            "Process automation, predictive analytics, neural networks",
                        icon: "focus-1",
                    },
                    {
                        title: "Internet of Things (IoT) and cyber-physical systems",
                        subtitle:
                            "Smart cities, sensor networks, digital ecology",
                        icon: "focus-2",
                    },
                    {
                        title: "Cybersecurity and critical infrastructure protection",
                        subtitle: "Cyberattack simulation, IDS/IPS development",
                        icon: "focus-3",
                    },
                    {
                        title: "Big data and business analytics",
                        subtitle:
                            "Analytics for urban planning, economy, and industry",
                        icon: "focus-4",
                    },
                    {
                        title: "Cloud computing and distributed systems",
                        subtitle: "Cloud computing and distributed systems",
                        icon: "focus1-1",
                    },
                    {
                        title: "Embedded systems and smart software",
                        subtitle: "Development for SCADA/ICS, IoT devices",
                        icon: "focus1-2",
                    },
                    {
                        title: "Computer vision and signal processing",
                        subtitle:
                            "Face recognition, video analysis, data classification",
                        icon: "focus1-3",
                    },
                ],
                subheadings: {
                    aboutUs:
                        "Innovative Center for Intellectual Systems Development",
                    directions: "Key technological directions",
                    materials:
                        "Open access to knowledge — for students, teachers, researchers, and everyone eager to master intellectual technologies. Theory, practice, certification.",
                    contacts: "Contact us",
                },
                missionPoints: [
                    {
                        title: "Development",
                        subtitle: "personal and professional growth",
                        icon: "growth",
                    },
                    {
                        title: "Collaboration",
                        subtitle: "interdisciplinary interaction",
                        icon: "cooperation",
                    },
                    {
                        title: "Innovation",
                        subtitle: "constant search for new solutions",
                        icon: "innovation",
                    },
                    {
                        title: "Security",
                        subtitle: "protection of the digital space",
                        icon: "security",
                    },
                    {
                        title: "Openness",
                        subtitle:
                            "integration into the global scientific community",
                        icon: "openness",
                    },
                ],
                newsCards: [
                    {
                        title: "Center students won the national hackathon",
                        text: "The team from the Institute of Computer Science developed a real-time cyberattack detection system and won 1st place at the CyberHack 2025 hackathon. Congratulations to the winners!",
                        image: "news-1",
                    },
                    {
                        title: "New machine learning course starts in September",
                        text: "The Center is opening enrollment for the author’s course “AI from zero to project”. The program includes real tasks, mentorship from experts, and certification. Limited seats available.",
                        image: "news-2",
                    },
                    {
                        title: "New machine learning course starts in September",
                        text: "The Innovative Center has joined a European project on developing cyber-physical systems in critical infrastructure. Ahead — new joint research and exchanges.",
                        image: "news-3",
                    },
                ],
                footerLinks: {
                    column1: [
                        "About us",
                        "News",
                        "Projects",
                        "Event announcements",
                    ],
                    column2: [
                        "Educational materials",
                        "Forum",
                        "Collaboration",
                        "My account",
                    ],
                },
                newsletter: {
                    title: "Want to stay updated? Leave your Email",
                    placeholder: "Email",
                    button: "Subscribe",
                },
                footer: {
                    copyrightLine1:
                        "© 2025 Innovative Center for Intellectual Systems Development",
                    copyrightLine2:
                        "V. N. Karazin Kharkiv National University. All rights reserved.",
                },
                common: {
                    scrollToTop: "Scroll to top",
                },
                aboutUs: {
                    alt: "Illustration for About Us section",
                },
            },
            about: {
                pageTitle: "About us",
                subtitle:
                    "The Information Technology Center is a structural unit of the Department of Computer Science, founded in 2007, which is engaged in improving computer literacy, international certification, and educational activities in the IT field.",
                headings: {
                    leadership: "Leadership",
                    developmentHistory: "Development history",
                },
                paragraphs: {
                    developmentHistory: ["Steps of establishment and growth"],
                    leadershipTitle: "Leaders shaping development",
                    leadershipText:
                        "The center's leaders define strategy, coordinate educational projects, and implement modern IT solutions.",
                },
                leadership: [
                    {
                        name: "Irina Savchenko",
                        position: "Deputy Dean for Research",
                    },
                    {
                        name: "Natalia Grinenko",
                        position: "Deputy Dean for Academic Affairs",
                    },
                    {
                        name: "Andriy Melnyk",
                        position: "Head of the Faculty Research Council",
                    },
                    {
                        name: "Olena Kovalchuk",
                        position: "Coordinator of International Programs",
                    },
                    {
                        name: "Serhiy Burchenko",
                        position:
                            "Director of the Innovation Center for Intelligent Systems Development",
                    },
                    {
                        name: "Svitlana Shevchenko",
                        position:
                            "Head of Educational and Methodological Department, Deputy Dean for Academic Affairs",
                    },
                ],
                history: {
                    founding: "2007 — Foundation",
                    foundingDescription:
                        "Establishment of the Information Center at the Department of Computer Science. Formation of the first team and launch of basic courses in programming and computer literacy.",
                    expansion:
                        "2008–2012 — Expansion of Educational Opportunities",
                    expansionDescription:
                        "Expansion of the range of educational programs, increase in the number of students and lecturers, creation of new courses in the field of information technologies.",
                    recognition: "2013–2018 — International Recognition",
                    recognitionDescription:
                        "Creation of a Cisco local academy, introduction of world-class certification courses, growth in the number of partners and students.",
                    innovation: "2019 – present — Innovation and Partnership",
                    innovationDescription:
                        "Development of cutting-edge educational programs, strengthening of international cooperation, organization of conferences, and implementation of innovative IT solutions.",
                },
            },
            news: {
                notFound: "News not found",
                pageTitle: "News",
                loadError: "Error loading news",
                filters: {
                    sortBy: "Sort by:",
                    datePublication: "Publication date",
                    dateNew: "Newest",
                    dateOld: "Oldest",
                    popularity: "Popularity",
                    mostPopular: "Most popular",
                    lessPopular: "Less popular",
                    listGroup: "List",
                    nameAZ: "By name (A-Z)",
                    nameZA: "By name (Z-A)",
                    similarSection: {
                        title: "Similar News",
                    },
                    share: {
                        title: "Share",
                        instagramApp: "Instagram sharing requires mobile app",
                        copied: "Link copied!",
                    },
                },
                meta: {
                    author: "Author",
                    views: "Views",
                    defaultAuthor: "Innovation Center Team",
                },
            },
            courses: {
                notFound: "Course not found",
                pageTitle: "Courses",
                loadError: "Error loading courses",
                noCourses: "No courses found",
                goToCourse: "Go to course",
                author: "Author",
                duration: "Duration",
                topic: "Topic",
                date: "Date",
                program: {
                    title: "Course Program",
                    placeholder:
                        "Course program information will be available soon",
                },
                similarSection: {
                    title: "You may also be interested",
                },
                filters: {
                    sortBy: "Sort by:",
                    dateNew: "Newest",
                    dateOld: "Oldest",
                    nameAZ: "By name (A-Z)",
                    nameZA: "By name (Z-A)",
                },
            },
            events: {
                location: {
                    online: "Online",
                    laboratory_center: "Laboratory Center",
                },
                format: {
                    online: "Online",
                    offline: "Offline",
                    hybrid: "Hybrid",
                },
            },
            educationalMaterials: {
                pageTitle: "Educational Materials",
                topics: {
                    title: "Topics",
                    clearAll: "Clear Filters",
                    expand: "Expand",
                    collapse: "Collapse",
                    ai: "Artificial Intelligence",
                    data_analysis: "Data Analysis",
                    programming: "Programming",
                    cybersecurity: "Cybersecurity",
                    iot: "Internet of Things",
                    research: "Scientific Research",
                    startups: "Innovation and Startups",
                    ai_ethics: "AI Ethics",
                },
                filters: {
                    title: "Filters",
                    sortBy: "Sort by:",
                },
                courses: {
                    title: "Courses",
                    noCourses: "No courses found",
                    moreCourses: "More courses",
                },
            },
        },
    },
};
